import { jsxs, jsx } from "react/jsx-runtime";
import assert from "assert";
import { optimizeResponsiveArray } from "../../utils/optimizeResponsiveArray.mjs";
import { resolveResponsiveRangeProps } from "../../utils/resolveResponsiveRangeProps.mjs";
import { Box } from "../Box/Box.mjs";
import { useBraidTheme } from "../BraidProvider/BraidThemeContext.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { Keyline } from "../private/Keyline/Keyline.mjs";
const validCardComponents = [
  "div",
  "article",
  "aside",
  "details",
  "main",
  "section"
];
const borderRadius = "large";
const Card = ({
  children,
  component = "div",
  tone,
  data,
  height,
  ...restProps
}) => {
  assert(
    validCardComponents.includes(component),
    `Invalid Card component: '${component}'. Should be one of [${validCardComponents.map((c) => `'${c}'`).join(", ")}]`
  );
  const isLegacyTheme = useBraidTheme().legacy;
  let resolvedRounding;
  if ("rounded" in restProps) {
    resolvedRounding = borderRadius;
  } else if ("roundedAbove" in restProps) {
    const [roundedOnMobile, roundedOnTablet, roundedOnDesktop, roundedOnWide] = resolveResponsiveRangeProps({ above: restProps.roundedAbove });
    resolvedRounding = optimizeResponsiveArray([
      roundedOnMobile ? borderRadius : "none",
      roundedOnTablet ? borderRadius : "none",
      roundedOnDesktop ? borderRadius : "none",
      roundedOnWide ? borderRadius : "none"
    ]);
  }
  const roundingForTheme = !isLegacyTheme ? borderRadius : resolvedRounding;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      component,
      position: "relative",
      background: "surface",
      padding: "gutter",
      borderRadius: roundingForTheme,
      boxShadow: !isLegacyTheme ? "borderNeutralLight" : void 0,
      height: height === "full" ? height : void 0,
      textAlign: "left",
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: [
        tone ? /* @__PURE__ */ jsx(Keyline, { tone, borderRadius: roundingForTheme }) : null,
        children
      ]
    }
  );
};
export {
  Card,
  validCardComponents
};
